"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationDetails = void 0;
const React = require("react");
const react_1 = require("react");
const useTickReRender_1 = require("../../../../../../hooks/useTickReRender");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const context_1 = require("../../../handlers/CustomerLocationHandler/context");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RetailLocationDetails");
const RetailLocationDetails = ({ retailLocation }) => {
    const { address: { fullAddress } } = retailLocation;
    const tick = (0, useTickReRender_1.useTickReRender)();
    const { customerLocation } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const latLng = (0, react_1.useMemo)(() => {
        if (!customerLocation) {
            return null;
        }
        const { lat, lng } = customerLocation;
        return {
            lat,
            lng
        };
    }, [customerLocation]);
    const isOnline = (0, react_1.useMemo)(() => {
        return retailLocation.isOnline;
    }, [tick]);
    const { operatingStatusLabel } = (0, useRetailLocationAvailability_1.useRetailLocationAvailability)(retailLocation);
    const distance = retailLocation.getLocationsDistance(latLng);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("status", { "-isOnline": isOnline }) }, operatingStatusLabel),
        React.createElement("div", { className: css("address") },
            fullAddress,
            !!latLng && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement("div", { className: css("distance") }, distance !== null
                    ? `${distance.toFixed(1)}km away`
                    : "Unknown distance"))))));
};
exports.RetailLocationDetails = RetailLocationDetails;
//# sourceMappingURL=index.js.map